import type { ExcludeOtherPaymentMethod } from '@/types/common';
import { TEXT_BY_PAYMENT_METHOD } from '@/constants/payment';
import { PaymentMethodEnum } from '@/types/common';
import { getImageSize } from '@/utils/style';
import { useTranslate } from '@/hooks/useTranslate';
import { getPaymentMethodBoxUrl } from '@/utils/paymentMethods';

export const PaymentMethodRow = ({ paymentMethod }: { paymentMethod: PaymentMethodEnum }) => {
  const { t } = useTranslate();

  const getPaymentMethodText = () => {
    if (paymentMethod === PaymentMethodEnum.CREDIT_CARD) {
      return t('payWithDebitOrCreditCard');
    }
    return TEXT_BY_PAYMENT_METHOD[paymentMethod as ExcludeOtherPaymentMethod];
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <img className={getImageSize(paymentMethod)} src={getPaymentMethodBoxUrl(paymentMethod)} alt={paymentMethod} />
      <div className="text-sm color-base-foreground">{getPaymentMethodText()}</div>
    </div>
  );
};
